// extracted by mini-css-extract-plugin
module.exports = {"catalogueFilters":"filters-module--catalogueFilters--2KHoO"};